export default __webpack_public_path__ + "static/media/arivaone2.77ce36d1.jpg";